import React from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Store, BookOpen, CreditCard, LogOut } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";

const links = [
  { to: "/admin", icon: LayoutDashboard, label: "Overview", end: true },
  { to: "/admin/restaurants", icon: Store, label: "Restaurants" },
  { to: "/admin/blogs", icon: BookOpen, label: "Blogs" },
  { to: "/admin/subscriptions", icon: CreditCard, label: "Subscriptions" },
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex bg-zq-cream">
      <aside className="w-64 zq-side flex flex-col p-4 hidden md:flex">
        <Link to="/admin" className="px-2 py-3"><Logo light /></Link>
        <nav className="mt-6 flex-1 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition ${
                  isActive ? "active" : ""
                }`
              }
            >
              <l.icon size={18} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <button
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:text-zq-orange"
          onClick={async () => { await logout(); nav("/login"); }}
          data-testid="admin-logout"
        >
          <LogOut size={16} /> Logout
        </button>
      </aside>

      <div className="flex-1 flex flex-col">
        <header className="h-14 bg-white border-b border-zq-border px-5 flex items-center justify-between">
          <span className="text-sm text-zq-muted">Admin · ZaykaQR</span>
          <span className="text-sm font-medium">{user?.name || user?.email}</span>
        </header>
        <main className="flex-1 p-5 md:p-8"><Outlet /></main>
      </div>
    </div>
  );
};
